export const worksheets = {
  actions: {
    start: 'Autoinformator',
    media: 'Media file',
    postback: 'Postback',
    menu: 'IVR'
  }
};
